import { MedicationField } from '../interfaces'

export const AUTH_SERVER_URL = import.meta.env.VITE_KEYCLOAK_URL ?? ''
export const CLIENT_ID = import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? ''
export const REALM = import.meta.env.VITE_KEYCLOAK_REALM ?? ''
export const DMS_API_URL = import.meta.env.VITE_DMS_API_URL
export const CRITICAL_BEDS_ID = import.meta.env.VITE_CRITICAL_BEDS
export const IPD_PROJECT_ID = import.meta.env.VITE_IPD_PROJECT_ID
export const OPD_PROJECT_ID = import.meta.env.VITE_OPD_PROJECT_ID
export const LABS_PROJECT_ID = import.meta.env.VITE_LABS_PROJECT_ID
export const CHAT_PROJECT_ID = import.meta.env.VITE_CHAT_PROJECT_ID
export const WEBSOCKET_URL = import.meta.env.VITE_WEBSOCKET_URL
export const APP_TYPE = import.meta.env.VITE_SOCKET_APP_TYPE
export const INTENSIVIST_DOCTOR_ID = import.meta.env.VITE_INTENSIVIST_DOCTOR_ID
export const JITSI_SECRET_KEY = import.meta.env.VITE_JITSI_SECRET_KEY
export const JITSI_APP_ID = import.meta.env.VITE_JITSI_APP_ID ?? ''

export const noPatientAvailableText =
  'No patients found for your search query/location.'
export const naText = 'N/A'
export const years = 'Years'
export const tests = 'Tests'
export const yesText = 'yes'
export const onHold = 'ONHOLD'
export const doctor = 'Doctor'
export const submit = 'Submit'
export const arrived = 'arrived'
export const careplan = 'careplan'
export const inactive = 'INACTIVE'
export const notInList = 'Not in List'
export const oneQuantityText = 'Qty-1'
export const medications = 'Medications'
export const actionPanel = 'Action Panel'
export const keepEditingText = 'Keep Editing'
export const noDataToShow = 'No data to show'
export const careplanHistory = 'Careplan History'
export const noMedications = 'No Medications found'
export const rejectionReason = 'Reason Of Rejection'
export const labSuggestionsText = 'Treatment Suggestions'
export const treatmentAndMedications = 'Treatment & Medications'
export const intensivistCommandCenter = 'Intensivist Command Centre'
export const careplanCreatedSuccessfully = 'Careplan created successfully'
export const medicationSubmitAlert =
  'Review and confirm the details before submission'
export const patientDetailsFailure =
  'Failed to get patient details, Please try again.'

export const prorithmMessageTypes = ['ADD', 'UPDATE', 'DELETE']

export const constants = {
  na: 'N/A',
  ipd: 'IPD',
  muhid: 'muhid',
  close: 'Close',
  online: 'Online',
  offline: 'Offline',
  admDate: 'Adm.Date',
  inactive: 'INACTIVE',
  location: 'LOCATION',
  homekare: 'HOMEKARE',
  clickaway: 'clickaway',
  heartbeat: 'HEARTBEAT',
  ambulance: 'AMBULANCE',
  connected: 'Connected',
  notMapped: 'NOT_MAPPED',
  error: 'error' as const,
  success: 'success' as const,
  disconnected: 'Disconnected',
  uncategorized: 'Uncategorized',
  mappingDetails: 'Mapping Details',
  loading: 'Loading. Please Wait...',
  exitFullscreen: 'Exit Full Screen',
  enterFullScreen: 'Enter Full Screen',
}

// Regex patterns
export const positiveDecimalNumberRegex =
  /^(?!0(\.0+)?$)(0?\.\d+|[1-9]\d*(\.\d+)?)$/
export const imageValidationRegex = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i
export const positiveIntegerRegex = /^[1-9]\d*$/
export const positiveMultipleOfDotFiveRegex =
  /^(?!0(\.0+)?$)(0?\.([05])|[1-9]\d*(\.\d+)?)$/

// intents
export const intent = {
  ipdDiagnosis: 'ipdDiagnosis',
  addToStaging: 'addToStaging',
  getCarePlans: 'getCarePlans',
  getDoctorsAPI: 'getDoctorsAPI',
  criticalBedLoc: 'criticalBedLoc',
  getDrugsByName: 'getDrugsByName',
  getAllPanelsApi: 'getAllPanelsApi',
  createVisitForCC: 'createVisitForCC',
  getPatientReports: 'getPatientReports',
  getPatientDetails: 'getPatientDetails',
  getWardsByLocation: 'getWardsByLocation',
  getLabOrdersForIPD: 'getLabOrdersForIPD',
  createNotification: 'createNotification',
  editMedicationById: 'editMedicationById',
  treatmentPlanForIPD: 'treatmentPlanForIPD',
  getAllSubEncounters: 'getAllSubEncounters',
  getDocIdForLabOrder: 'getDocIdForLabOrder',
  getallVisitmedication: 'getallVisitmedication',
  getDrugsByComposition: 'getDrugsByComposition',
  fetchObservationsForCC: 'fetchObservationsForCC',
  getEncounterAndDocName: 'getEncounterAndDocName',
  getCriticalBedsByLocation: 'getCriticalBedsByLocation',
  getMedicineAdministration: 'getMedicineAdministration',
  getAdministerMedicineById: 'getAdministerMedicineById',
  getBedDetailsByLocationAndWards: 'getBedDetailsByLocationAndWards',
}

// routes
export const routes = {
  homeRoute: '/',
  videoCall: '/videoCall',
  prorithmVitals: '/prorithm/vitals',
  navigateProrithmVital: '/prorithm/vitals/',
  prorithmDashboard: '/prorithm/dashboard',
}

export const bpColors = [
  '#D85A3E',
  '#E79F3C',
  '#D8CE4A',
  '#52C969',
  '#D8CE4A',
  '#E79F3C',
  '#D85A3E',
]
export const skinTempColors = [
  '#CF2E06',
  '#EDDF0C',
  '#0CED1D',
  '#EDDF0C',
  '#CF2E06',
]

export const patientDemographicData = {
  age: 'Age',
  name: 'Name',
  uhid: 'UHID',
  bed: 'Bed No.',
  room: 'Room No.',
  gender: 'Gender',
  ward: 'Ward Name',
}

export const treatmentAndMedicationsMessages = {
  na: 'N/A',
  startDate: 'startDate',
  continuous: 'Continuous',
  week: 'week',
  day: 'day',
  month: 'month',
  twoWeek: '2 week',
  careplanDetails: 'Careplan details',
  careplanSuccess: 'Careplan created successfully',
  frequencySelectedOnceADay: 'Frequency selected as ONCE A DAY',
  frequencySelectedOnceAWeek: 'Frequency selected as ONCE A WEEK',
  frequencySelectedTwiceADay: 'Frequency selected as TWICE A DAY',
  frequencySelectedTwiceAWeek: 'Frequency selected as TWICE A WEEK',
  frequencySelectedThriceADay: 'Frequency selected as THRICE A DAY',
  frequencySelectedThreeDaysAWeek: 'Frequency selected as THREE DAYS A WEEK',
  frequencySelectedFourTimesADay: 'Frequency selected as FOUR TIMES A DAY',
  frequencySelectedFourDaysAWeek: 'Frequency selected as FOUR DAYS A WEEK',
  frequencySelectedFiveTimesADay: 'Frequency selected as FIVE TIMES A DAY',
  frequencySelectedFiveDaysAWeek: 'Frequency selected as FIVE DAYS A WEEK',
  frequencySelectedSixDaysAWeek: 'Frequency selected as SIX DAYS A WEEK',
  positiveWholeNumberAccepted: 'Only positive whole numbers are accepted.',
  greaterthanZeroandMultipleOfFive:
    'Value must be > 0 and must be in multiple of 0.5',
  valueGreaterThanZero: 'Value must be greater than zero.',
  patientIdNotProvided: 'Patient Id is not provided',
  locationNotProvided: 'Location is not provided',
  noDatesProvided: 'No dates provided or dates array is empty',
  unableToCreateCarePlan: 'Unable to create Careplan. Please try again.',
  greaterThanZero: 'Value must be greater than 0 and must be whole number',
  onHold: 'ON HOLD',
  ACCEPTED: 'ACCEPTED',
  PROCESSED: 'PROCESSED',
  REJECTED: 'REJECTED',
  STAGING: 'STAGING',
  accepted: 'Accepted',
  rejected: 'Rejected',
  pending: 'Pending',
  onceADay: 'Once a day',
  twiceADay: 'Twice a day',
  immediately: 'Immediately',
  fourTimesADay: 'Four times a day',
  thriceADay: 'Thrice a day',
  fiveTimesADay: 'Five times a day',
  onAlternateDays: 'On alternate days',
  onceAWeek: 'Once a week',
  twiceAWeek: 'Twice a week',
  threeDaysAWeek: 'Thrice a week',
  fourDaysAWeek: 'Four days a week',
  fiveDaysAWeek: 'Five days a week',
  sixDaysAWeek: 'Six days a week',
  everyHour: 'Every Hour',
  everyTwoHour: 'Every 2 hours',
  everyThreeHour: 'Every 3 hours',
  everyTwoWeeks: 'Every 2 weeks',
  everyThreeWeeks: 'Every 3 weeks',
  everyFourHour: 'Every 4 hours',
  everySixHour: 'Every 6 hours',
  everyEightHour: 'Every 8 hours',
  everyTwelveHour: 'Every 12 hours',
  selectAtLeastOneDate: 'Please select at least one date',
  acceptedTitleCase: 'Accepted',
  days: 'Day(s)',
  weeks: 'Week(s)',
  months: 'Month(s)',
  visitCreationFailure: 'Failed to create a visit',
}

export const treatmentAndMedicationMecalHistory = {
  status: 'Status',
  reason: 'Reason',
  serialNO: 'Sl. No',
  details: 'Details',
  startTime: 'Start Time',
  actionTime: ' Action Time',
  doctorName: 'Doctor Name',
}

export const labReports = {
  placeholder: '-',
  tat: 'TAT',
  view: 'View',
  test: 'Test',
  slNo: 'S No',
  labId: 'Lab ID',
  status: 'Status',
  doctor: 'Doctor',
  completed: 'COMPLETED',
  requestedBy: 'Requested By',
  dateAndTime: '(Ordered) Date & Time',
  noLabOrdersFound: 'No Lab Orders Found',
  reportUnavailableMessage: 'Report Unavailable! Please contact administrator',
}

export const diagnosisText = {
  slNo: 'S No',
  view: 'View',
  date: 'Date',
  close: 'Close',
  noData: 'No Data',
  showLess: 'Show Less',
  showMore: 'Show more',
  selectDate: 'Select Date',
  doctorName: 'Doctor Name',
  finalDiagnosis: 'Final Diagnosis',
  diagnosisDetails: 'Diagnosis Details',
  investigations: 'Investigations/Diagnostics',
  provisionalDiagnosis: 'Provisional Diagnosis',
  differentialDiagnosis: 'Differential Diagnosis',
  intensivistCommandCenter: 'Intensivist Command Centre',
}

export const treatment = {
  yes: 'yes',
  slNo: 'S No',
  view: 'View',
  date: 'Date',
  close: 'Close',
  noData: 'No Data',
  showLess: 'Show less',
  showMore: 'Show more',
  department: 'Department',
  selectDate: 'Select Date',
  doctorName: 'Doctor Name',
  treatmentPlan: 'Treatment Plan',
  reasonReferral: 'Reason Referral',
  nameOfDoctor: 'Name Of the Doctor',
  referralRequired: 'Referral Required',
  treatmentSuggestions: 'Treatment Suggestions',
}

export const assesmentText = {
  date: 'Date',
  slNo: 'S No',
  title: 'Title',
  close: 'Close',
  view: 'Preview',
  noData: 'No Data',
  download: 'Download',
  showLess: 'Show less',
  showMore: 'Show more',
  department: 'Department',
  selectDate: 'Select Date',
  dateOfUpload: 'Date Of Upload',
  treatmentPlan: 'Treatment Plan',
  reasonReferral: 'Reason Referral',
  nameOfDoctor: 'Name Of the Doctor',
  referralRequired: 'Referral Required',
  treatmentSuggestions: 'Treatment Suggestions',
}

export const labReportMedications = {
  no: 'No',
  yes: 'Yes',
  slNo: 'S No',
  dose: 'Dose',
  route: 'Route',
  actions: 'Actions',
  endDate: 'End Date',
  duration: 'Duration',
  drugName: 'Drug Name',
  frequency: 'Frequency',
  intervals: 'Intervals',
  doseUnits: 'Dose Units',
  startDate: 'Start Date',
  discontinue: 'Discontinue',
  addInstructions: 'Add. Instructions',
  discontinueConfirm: 'Are you sure you want to discontinue',
}

export const medicationsTable = {
  dose: 'Dose',
  unit: 'Unit',
  route: 'Route',
  order: 'Order',
  action: 'Action',
  endDate: 'End Date',
  interval: 'Interval',
  totalQty: 'Total Qty',
  frequency: 'Frequency',
  sos: 'SOS/Instructions',
  startDate: 'Start Date',
  duration: 'Duration/Units',
  medicineName: 'Medicine Name',
  searchAlternative: 'Search Alternative',
}

export const unitOptions = [
  { name: 'Capsule(s)', value: 'capsule' },
  { name: 'Tablet(s)', value: 'tablet' },
  { name: 'ml', value: 'ml' },
  { name: 'mg', value: 'mg' },
  { name: 'IU', value: 'iu' },
  { name: 'Drop', value: 'drop' },
  { name: 'Tablespoon', value: 'tablespoon' },
  { name: 'Teaspoon', value: 'teaspoon' },
  { name: 'Unit(s)', value: 'unit' },
  { name: 'Puff(s)', value: 'puff' },
]

export const routeOptions = [
  { name: 'Buccal', value: 'buccal' },
  { name: 'Epidural', value: 'epidural' },
  { name: 'Inhalation', value: 'inhalation' },
  { name: 'Infusion', value: 'infusion' },
  { name: 'Intra-articular', value: 'intra-articular' },
  { name: 'Intracardiac', value: 'intracardiac' },
  { name: 'Intradermal', value: 'intradermal' },
  { name: 'Intraocular', value: 'intraocular' },
  { name: 'Intraosseous', value: 'intraosseous' },
  { name: 'Intraperitoneal', value: 'intraperitoneal' },
  { name: 'Intranasal', value: 'intranasal' },
  { name: 'Intrathecal', value: 'intrathecal' },
  { name: 'Intravaginal', value: 'intravaginal' },
  { name: 'Intravenous', value: 'intravenous' },
  { name: 'Nasogastric', value: 'nasogastric' },
  { name: 'Nasal', value: 'nasal' },
  { name: 'Ophthalmic', value: 'ophthalmic' },
  { name: 'Oral', value: 'oral' },
  { name: 'Otic', value: 'otic' },
  { name: 'Per Rectum', value: 'perrectum' },
  { name: 'Per-Vaginal', value: 'per-vaginal' },
  { name: 'Rectal', value: 'rectal' },
  { name: 'Sub Lingual', value: 'sublingual' },
  { name: 'Subcutaneous', value: 'subcutaneous' },
  { name: 'Topical', value: 'topical' },
  { name: 'Transdermal', value: 'transdermal' },
]

export const frequencyOptions = [
  {
    name: treatmentAndMedicationsMessages?.immediately,
    value: treatmentAndMedicationsMessages?.immediately,
  },
  {
    name: treatmentAndMedicationsMessages?.onceADay,
    value: treatmentAndMedicationsMessages?.onceADay,
  },
  {
    name: treatmentAndMedicationsMessages?.twiceADay,
    value: treatmentAndMedicationsMessages?.twiceADay,
  },
  {
    name: treatmentAndMedicationsMessages?.thriceADay,
    value: treatmentAndMedicationsMessages?.thriceADay,
  },
  {
    name: treatmentAndMedicationsMessages?.fourTimesADay,
    value: treatmentAndMedicationsMessages?.fourTimesADay,
  },
  {
    name: treatmentAndMedicationsMessages?.everyFourHour,
    value: treatmentAndMedicationsMessages?.everyFourHour,
  },
  {
    name: treatmentAndMedicationsMessages?.everySixHour,
    value: treatmentAndMedicationsMessages?.everySixHour,
  },
  {
    name: treatmentAndMedicationsMessages?.onAlternateDays,
    value: treatmentAndMedicationsMessages?.onAlternateDays,
  },
  {
    name: treatmentAndMedicationsMessages?.onceAWeek,
    value: treatmentAndMedicationsMessages?.onceAWeek,
  },
  {
    name: treatmentAndMedicationsMessages?.twiceAWeek,
    value: treatmentAndMedicationsMessages?.twiceAWeek,
  },
  {
    name: treatmentAndMedicationsMessages?.threeDaysAWeek,
    value: treatmentAndMedicationsMessages?.threeDaysAWeek,
  },
  {
    name: treatmentAndMedicationsMessages?.fourDaysAWeek,
    value: treatmentAndMedicationsMessages?.fourDaysAWeek,
  },
  {
    name: treatmentAndMedicationsMessages?.fiveDaysAWeek,
    value: treatmentAndMedicationsMessages?.fiveDaysAWeek,
  },
  {
    name: treatmentAndMedicationsMessages?.sixDaysAWeek,
    value: treatmentAndMedicationsMessages?.sixDaysAWeek,
  },
  {
    name: treatmentAndMedicationsMessages?.continuous,
    value: treatmentAndMedicationsMessages?.continuous,
  },
]

export const durationUnits = [
  { name: 'Hour(s)', value: 'hour' },
  { name: 'Day(s)', value: 'day' },
  { name: 'Month(s)', value: 'month' },
  { name: 'Week(s)', value: 'week' },
]

export const instructions = [
  { name: 'Before meals', value: 'beforemeals' },
  { name: 'Empty stomach', value: 'emptystomach' },
  { name: 'After meals', value: 'aftermeals' },
  { name: 'In the morning', value: 'inmorning' },
  { name: 'In the evening', value: 'inevening' },
  { name: 'At bedtime', value: 'bedtime' },
  { name: 'Immediately', value: 'immediately' },
  { name: 'As directed', value: 'directed' },
]

export const treatmentsText = {
  add: 'Add',
  lunch: 'Lunch',
  remove: 'Remove',
  select: 'Select',
  dinner: 'Dinner',
  breakfast: 'Breakfast',
  startingFrom: 'Starting From',
  noOptionsFound: 'No Options Found',
  selectAnOption: 'Select an options',
}

export const layout = {
  default: 'Default',
  patientData: 'Patient Data',
  intensivists: 'Intensivists',
  selectLayout: 'Select Layout',
  patientVitals: 'Patient Vitals',
  patientDashboard: 'Patient Dashboard',
}

export const ambulanceText = {
  bpm: 'bpm',
  pro: 'pro',
  spo2: 'SpO2',
  rithm: 'RiTHM',
  fromECG: 'From ECG',
  systolic: 'Systolic',
  skinTemp: 'Skin Temp',
  lenError: 'len_error',
  diastolic: 'Diastolic',
  heartRate: 'Heart Rate',
  bloodPressure: 'Blood Pressure',
  respiratoryRate: 'Respiratory Rate',
  processingFromDevice: 'Processing from device',
  processingFromECG: 'Processing from ECG & PPG',
  noDataToDisplay: 'No data to display.',
  noLiveFeedText: 'Live Feed Unavailable.',
  deviceStatus: 'Device Status:',
  noStatusAvailable: 'No Status Available',
  lastUpdated: 'Last updated:',
}

export const patientDashboard = {
  bp: 'BP',
  art: 'ART',
  ecg: 'ECG',
  name: 'Name',
  spo2: 'SpO2',
  view: 'View',
  actions: 'Actions',
  critical: 'critical',
  mrNumber: 'MR Number',
  selectWard: 'Select Ward',
  lastVisited: 'Last Visited',
  selectLocation: 'Select Location',
  respiratoryRate: 'Respiratory Rate',
  wardSelection: 'Please select a ward',
  noWardsAvailable: 'No wards available',
  openingPatientInPod: 'Opening patient in POD...',
  patientNotFoundInPod: 'Unable to open. Patient not found in POD',
  loadingPatients: 'No patients found for your search query/location',
  refreshPageMessage: 'Please refresh the page to receive real-time data.',
  liveFeedStoppedMessage:
    'Live feed stopped. Please click Refresh to receive live feed.',
  liveFeedErrorMessage:
    'The connection was lost unexpectedly. Please click Refresh to reconnect.',
  refreshButton: 'Refresh',
  dismissButton: 'Dismiss',
  liveFeedStoppedTitle: 'Live feed stopped',
}

export const historyVitals = {
  spo2: 'SpO2',
  systolicBP: 'Systolic BP',
  diastolicBP: 'Diastolic BP',
  ecgHeartRate: 'ECG Heart Rate',
  respiratoryRate: 'Respiratory Rate',
  arterialSystolic: 'Arterial Systolic',
  arterialDiastolic: 'Arterial Diastolic',
  eightHoursInterval: 'Duration: 8Hrs, Interval: 15Mins',
}

export const historyCharts = {
  ecgHeartRate: 'ECG Heart Rate',
  ecgHeartRateCode: 'ecgHeartRate',
  systolicBP: 'Systolic BP',
  systolicBpValue: 'systolicBpValue',
  diastolicBP: 'Diastolic BP',
  diastolicBpValue: 'diastolicBpValue',
  spo2: 'SPO2',
  spo2Value: 'spo2',
  respiratoryValue: 'Respiratory Value',
  respiratoryValueCode: 'respiratoryValue',
  systolicBpLayout: 'systolicBP',
  diastolicBpLayout: 'diastolicBP',
  arterialSys: 'artSystolic',
  arterialDia: 'artDiastolic',
  artSystolic: 'Arterial Systolic',
  artDiastolic: 'Arterial Diastolic',
  currentlyViewing: 'Currently viewing:',
  none: 'None',
  arterialSysValue: 'arterialSys',
  arterialDiaValue: 'arterialDia',
  historyInterval:
    'Duration: ' +
    import.meta.env.VITE_VITAL_HISTORY_DURATION +
    ', Interval: ' +
    import.meta.env.VITE_VITAL_HISTORY_INTERVAL,
}

export const videoCall = {
  or: 'OR',
  selectRoom: 'Select a room',
  selectARoom: 'Select a room',
  startVideoCall: 'Start Video Call',
  selectExistingRoom: 'Select existing room',
  enterRoomPlaceholder: 'Enter room name in title case',
  roomNameHelperText:
    'Use complex room names (Min length: 12) like: CommandCenterUrgentCall',
  recordingFeatureUnavailable:
    'Recording facility unavailable. You can still continue with the call.',
}

export const videoRooms = [
  { value: 'CommandCenterPodOne', label: 'POD 1' },
  { value: 'CommandCenterPodTwo', label: 'POD 2' },
  { value: 'CommandCenterConferenceRoom', label: 'Conference Room' },
  {
    value: 'CommandCenterTeleConsultationOne',
    label: 'Teleconsultation One',
  },
  {
    value: 'CommandCenterTeleConsultationTwo',
    label: 'Teleconsultation Two',
  },
  {
    value: 'CommandCenterTeleConsultationThree',
    label: 'Teleconsultation Three',
  },
]

export const medicationAdministration = {
  route: 'Route',
  dosage: 'Dosage',
  medicine: 'Medicine',
  frequency: 'Frequency',
  duration: 'Duration(units)',
  noData: 'No Medicines for the day',
}

export const allocation = {
  assigned: 'ASSIGNED',
  critical: 'critical',
  occupied: 'OCCUPIED',
  nonCritical: 'non-critical',
}

export const alerts = {
  low: 'Low',
  high: 'High',
  lowerThanLimit: 'Lower than limit',
  higherThanLimit: 'Higher than limit',
  alertsError:
    'Patient details not found, Please check Patient ID in Mindray device',
}

export const hospitals = {
  vitalsLayout: 'vitals',
  defaultLayout: 'default',
  patientDataLayout: 'patientData',
  intensivistsLayout: 'intensivists',
  serachPlaceholder: 'Name,ID,MR Number',
  patientDashboardLayout: 'patientDashboard',
  noneLayout: 'none',
}

export const layoutOptions = [
  {
    value: 'none',
    label: 'Select Layout',
  },
  {
    value: 'patientDashboard',
    label: 'Patient Dashboard',
  },
  {
    value: 'vitals',
    label: 'Patient Vitals',
  },
  {
    value: 'patientData',
    label: 'Patient Data',
  },
  {
    value: 'intensivists',
    label: 'Intensivists',
  },
  {
    value: 'default',
    label: 'Default',
  },
]

export const sidebarTexts = {
  no: 'NO',
  yes: 'YES',
  prorithmDashboard: 'Prorithm Dashboard',
  prorithmVitals: 'Prorithm Vitals',
  currentlyLoggedIn: 'Currently logged in as',
  logoutConfirm: 'Are you sure you want to logout?',
}

export const sidebarPatientLayout = {
  vitals: 'vitals',
  default: 'default',
  patientData: 'patientData',
  intensivists: 'intensivists',
}

export const thopNotificationAlertType = {
  careplan: 'careplan',
  statusAccepted: 'statusAccepted',
  statusRejected: 'statusRejected',
  acceptCareplan: 'accept-careplan',
  rejectCareplan: 'reject-careplan',
  newIpdDataUpdate: 'newIpdDataUpdate',
  deleteIpdRegistration: 'deleteIpdRegistration',
  newIpdRegistrationUpdate: 'newIpdRegistrationUpdate',
}

export const ChartDataType = {
  ecg: 'ecg',
  resp: 'resp',
  pulse: 'pulse',
  bloodPressure: 'bloodPressure',
}

export const channelsType = {
  resp: 'Resp',
  pleth: 'Pleth',
  bloodPressure: 'Blood pressure',
  electrocardiogram: 'Electrocardiogram',
}

export const noResponseData = {
  hyphenString: '-',
  emptyString: '',
  emptyArray: [],
}

export const careplanInfo = {
  medications: 'Medications:',
  noMedications: 'No Medications',
  breakfast: 'breakfast',
  lunch: 'lunch',
  dinner: 'dinner',
  beforeBreakfast: 'bb',
  afterBreakfast: 'ab',
  beforeLunch: 'bl',
  afterLunch: 'al',
  beforeDinner: 'bd',
  afterDinner: 'ad',
  before: 'before',
  after: 'after',
  Doctor: ' Doctor:',
  treatmentSuggestions: 'Treatment Suggestions:',
}

export const medication = {
  immediately: 'Immediately',
  onceADay: 'Once a day',
  twiceADay: 'Twice a day',
  fiveTimesADay: 'Five times a day',
  thriceADay: 'Thrice a day',
  fourTimesADay: 'Four times a day',
  hour: 'hour',
  everyTwoWeeks: 'Every 2 weeks',
  everyThreeWeeks: 'Every 3 weeks',
  onAlternateDays: 'On alternate days',
}

export const medicationFields: MedicationField[] = [
  {
    key: 'medicineName',
    align: 'left',
    id: 'medicine-name-text',
    testId: 'medicine-name-header',
  },
  { key: 'dose', align: 'left', id: 'dose-text', testId: 'dose-header' },
  { key: 'unit', align: 'left', id: 'unit-text', testId: 'unit-header' },
  { key: 'route', align: 'center', id: 'route-text', testId: 'route-header' },
  {
    key: 'frequency',
    align: 'center',
    id: 'frequency-text',
    testId: 'frequency-header',
  },
  {
    key: 'interval',
    align: 'center',
    id: 'interval-text',
    testId: 'interval-header',
  },
  {
    key: 'duration',
    align: 'center',
    id: 'duration-text',
    testId: 'duration-header',
  },
  {
    key: 'totalQty',
    align: 'center',
    id: 'total-quantity-text',
    testId: 'total-quantity-header',
  },
  {
    key: 'startDate',
    align: 'center',
    id: 'start-date-text',
    testId: 'start-date-header',
  },
  {
    key: 'endDate',
    align: 'center',
    id: 'end-date-text',
    testId: 'end-date-header',
  },
  { key: 'sos', align: 'center', id: 'sos-text', testId: 'sos-header' },
  {
    key: 'action',
    align: 'center',
    id: 'action-text',
    testId: 'action-header',
  },
]

export const dayFrequencies = [
  treatmentAndMedicationsMessages?.onceADay,
  // treatmentAndMedicationsMessages?.immediately,
  treatmentAndMedicationsMessages?.twiceADay,
  treatmentAndMedicationsMessages?.thriceADay,
  treatmentAndMedicationsMessages?.fourTimesADay,
  treatmentAndMedicationsMessages?.fiveTimesADay,
]

export const multipleDateFrequencies = [
  treatmentAndMedicationsMessages?.onAlternateDays,
  treatmentAndMedicationsMessages?.onceAWeek,
  treatmentAndMedicationsMessages?.twiceAWeek,
  treatmentAndMedicationsMessages?.threeDaysAWeek,
  treatmentAndMedicationsMessages?.fourDaysAWeek,
  treatmentAndMedicationsMessages?.fiveDaysAWeek,
  treatmentAndMedicationsMessages?.sixDaysAWeek,
]

export const hourlyFrequencies = [
  treatmentAndMedicationsMessages?.everyHour,
  treatmentAndMedicationsMessages?.everyTwoHour,
  treatmentAndMedicationsMessages?.everyThreeHour,
  treatmentAndMedicationsMessages?.everyFourHour,
  treatmentAndMedicationsMessages?.everySixHour,
  treatmentAndMedicationsMessages?.everyEightHour,
  treatmentAndMedicationsMessages?.everyTwelveHour,
]

export const prorithmStatus = [
  {
    statusCode: 200,
    statusName: 'Connected',
    meaning: 'proRITHM Device is now connected with the app.',
  },
  {
    statusCode: 201,
    statusName: 'Test Completed',
    meaning: 'Medical test completed successfully on the proRITHM Device.',
  },
  {
    statusCode: 202,
    statusName: 'Paused',
    meaning:
      'proRITHM device is connected, but the medical test is paused in the app.',
  },
  {
    statusCode: 203,
    statusName: 'Started',
    meaning:
      'The device is connected to the backend and the medical test has started.',
  },
  {
    statusCode: 204,
    statusName: 'Stopped',
    meaning: 'The proRITHM device has stopped.',
  },
  {
    statusCode: 401,
    statusName: 'Token Expired',
    meaning: 'The authentication token has expired, please re-login again.',
  },
  {
    statusCode: 410,
    statusName: 'Disconnected',
    meaning: 'The proRITHM device has been disconnected from the app.',
  },
  {
    statusCode: 422,
    statusName: 'Not Placed',
    meaning:
      'The proRITHM device is not properly placed on the patient. Check the ECG leads on patient.',
  },
  {
    statusCode: 503,
    statusName: 'Internet Issue',
    meaning:
      'Please check your internet connection. The app is not connected due to a poor network.',
  },
]
